import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  PLATFORM_ID,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '../../shared/services/api.service';
import { secureStorage } from '../../shared/services/secure-storage.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { LoaderService } from '../../shared/services/loader.service';
import { NotificationService } from '../../shared/services/notification.service';

@Component({
  selector: 'app-payment',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss',
})
export class PaymentComponent implements OnInit, OnDestroy {
  @Output() selectedPartNumbersChange = new EventEmitter<any[]>();
  @Output() priceDetailsChange = new EventEmitter<any>();
  activeTab: string = 'home';
  isHomeDelivery: boolean = true;
  currentAddress: Address;

  homeDeliveryAddress: Address = {
    name: 'Harsh Kumawat',
    pincode: '400615',
    addressType: 'Work',
    fullAddress:
      '1205, Lodha Supremus, Lodha Business District Gate. 2, Airforce Road, Kolshet Rd, Sandoz Baugh, Thane, Maharashtra 400607',
  };

  storePickupAddress: Address = {
    name: 'RVSF Parmashwari',
    pincode: '400625',
    fullAddress:
      '1205, Lodha Supremus, Lodha Business District Gate. 2, Airforce Road, Kolshet Rd, Sandoz Baugh, Thane, Maharashtra 400607',
  };
  homeDeliveryProducts: any[] = [];

  storePickupProducts: any[] = [];

  priceDetails: any;
  sub: Subscription = new Subscription();
  selectedItems: any;
  userData: any;
  selectedPartNumber: any;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private notificationService: NotificationService,

    // private localstorage: secureStorage
  ) {
    this.currentAddress = this.homeDeliveryAddress;
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Subscribe to user data changes
      this.sub.add(
        this.authService.userData$.subscribe((userData) => {
          this.userData = userData || {};
          console.log('1111111111111111111', this.userData);
        }),
      );

      this.setActiveTab('home');
      setTimeout(() => {
        this.loaderService.show();
        this.getCartDataPayment();
      }, 1000);
    }
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    this.isHomeDelivery = tab === 'home';
    this.currentAddress = this.isHomeDelivery
      ? this.homeDeliveryAddress
      : this.storePickupAddress;
  }

  // getCartDataPayment() {

  //   const payload =
  //     {
  //       // "offset": 0,
  //       // "limit": 10,
  //       "action_type": "GET_LIST",
  //       // "delivery_type":this.isHomeDelivery ? "Home Delivery" : "Store Pickup",
  //       "get_selected_parts":true,
  //       "cart_items":"" }
  //   this.sub.add( this.apiService.getCartData(payload).subscribe({
  //     next: (res: any) => {
  //       if (res.success) {
  //         this.selectedItems = res.data.cart_items;
  //         this.priceDetails = res.data.get_price_breakup;
  //         this.selectedPartNumber = this.selectedItems.map((item: any) => item.part_number);

  //           this.storePickupProducts = this.selectedItems.filter((item: any) => item.delivery_type === "Store Pickup");
  //           this.homeDeliveryProducts = this.selectedItems.filter((item: any) => item.delivery_type === "Home Delivery");
  //           if (this.homeDeliveryProducts.length === 0) {
  //             this.setActiveTab('store');
  //           }
  //         this.selectedPartNumbersChange.emit(this.selectedPartNumber);
  //         this.priceDetailsChange.emit(this.priceDetails);
  //         this.loaderService.hide();
  //       }
  //       this.loaderService.hide();

  //     },
  //     error: (error) => {        console.error('Error fetching cart data:', error);
  //       this.loaderService.hide();
  //       this.notificationService.error(error?.error?.data?.msg || 'Failed to fetch cart data. Please try again.');
  //   }));
  // }

  getCartDataPayment(): void {
    const payload = {
      action_type: 'GET_LIST',
      get_selected_parts: true,
      cart_items: '',
    };

    this.loaderService.show();

    this.sub.add(
      this.apiService.getCartData(payload).subscribe({
        next: (res: any) => {
          if (res?.success && res?.data) {
            const cartItems = res.data.cart_items || [];

            this.selectedItems = cartItems;
            this.priceDetails = res.data.get_price_breakup || [];

            // Extract part numbers
            this.selectedPartNumber = cartItems.map(
              (item: any) => item.part_number,
            );

            // Single loop optimization
            this.storePickupProducts = [];
            this.homeDeliveryProducts = [];

            cartItems.forEach((item: any) => {
              if (item.delivery_type === 'Store Pickup') {
                this.storePickupProducts.push(item);
              } else if (item.delivery_type === 'Home Delivery') {
                this.homeDeliveryProducts.push(item);
              }
            });

            // Default tab handling
            if (this.homeDeliveryProducts.length === 0) {
              this.setActiveTab('store');
            }

            // Emit events
            this.selectedPartNumbersChange.emit(this.selectedPartNumber);
            this.priceDetailsChange.emit(this.priceDetails);
          }
        },
        error: (error) => {
          console.error('Error fetching cart data:', error);
          this.notificationService.error(
            error?.error?.data?.msg ||
              'Failed to fetch cart data. Please try again.',
          );
        },
        complete: () => {
          this.loaderService.hide(); // ✅ only once
        },
      }),
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}

// interface ProductItem {
//   id: string;
//   title: string;
//   image: string;
//   grade?: string;
//   brand?: string;
//   model?: string;
//   year?: string;
//   specs?: string;
//   description?: string;
//   seller: string;
//   deliveryDate: string;
// }

interface Address {
  name: string;
  pincode: string;
  addressType?: string;
  fullAddress: string;
}
